import {
  ADD_SERVICE,
  ADD_SERVICE_FAILURE,
  ADD_SERVICE_SUCCESS,
  ADD_THIRD_LAYER_SERVICES,
  ADD_THIRD_LAYER_SERVICES_FAILURE,
  ADD_THIRD_LAYER_SERVICES_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_FAILURE,
  DELETE_SERVICE_SUCCESS,
  DELETE_SUB_SERVICE,
  DELETE_SUB_SERVICE_FAILURE,
  DELETE_SUB_SERVICE_SUCCESS,
  GET_ALL_SERVICES,
  GET_ALL_SERVICES_FAILURE,
  GET_ALL_SERVICES_SUCCESS,
  GET_ALL_SUB_SERVICES,
  GET_ALL_SUB_SERVICES_FAILURE,
  GET_ALL_SUB_SERVICES_SUCCESS,
  UPDATE_PRIORITY,
  UPDATE_PRIORITY_FAILURE,
  UPDATE_PRIORITY_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_FAILURE,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_SUB_SERVICES,
  UPDATE_SUB_SERVICES_FAILURE,
  UPDATE_SUB_SERVICES_SUCCESS,
} from "../constants";

export default class ServiceAction {
  static getAllServices(payload, cb) {
    return {
      type: GET_ALL_SERVICES,
      payload,
      cb,
    };
  }
  static getAllServicesSuccess(payload) {
    return {
      type: GET_ALL_SERVICES_SUCCESS,
      payload,
    };
  }
  static getAllServicesFailure(payload) {
    return {
      type: GET_ALL_SERVICES_FAILURE,
      payload,
    };
  }
  static getAllSubServices(id, cb) {
    return {
      type: GET_ALL_SUB_SERVICES,
      id,
      cb,
    };
  }
  static getAllSubServicesSuccess(payload) {
    return {
      type: GET_ALL_SUB_SERVICES_SUCCESS,
      payload,
    };
  }
  static getAllSubServicesFailure(payload) {
    return {
      type: GET_ALL_SUB_SERVICES_FAILURE,
      payload,
    };
  }
  static addService(payload, cb) {
    return {
      type: ADD_SERVICE,
      payload,
      cb,
    };
  }
  static addServiceSuccess(payload) {
    return {
      type: ADD_SERVICE_SUCCESS,
      payload,
    };
  }
  static addServiceFailure(payload) {
    return {
      type: ADD_SERVICE_FAILURE,
      payload,
    };
  }
  static deleteService(id, cb) {
    return {
      type: DELETE_SERVICE,
      id,
      cb,
    };
  }
  static deleteServiceSuccess(payload) {
    return {
      type: DELETE_SERVICE_SUCCESS,
      payload,
    };
  }
  static deleteServiceFailure(payload) {
    return {
      type: DELETE_SERVICE_FAILURE,
      payload,
    };
  }
  static updateService(id, payload, cb) {
    return {
      type: UPDATE_SERVICE,
      id,
      payload,
      cb,
    };
  }
  static updateServiceSuccess(payload) {
    return {
      type: UPDATE_SERVICE_SUCCESS,
      payload,
    };
  }
  static updateServiceFailure(payload) {
    return {
      type: UPDATE_SERVICE_FAILURE,
      payload,
    };
  }
  static updateSubServices(payload, cb) {
    return {
      type: UPDATE_SUB_SERVICES,
      cb,
      payload
    }
  }
  static updateSubServicesSuccess() {
    return {
      type: UPDATE_SUB_SERVICES_SUCCESS,
    }
  }
  static updateSubServicesFailure() {
    return {
      type: UPDATE_SUB_SERVICES_FAILURE,
    }
  }

  static deleteSubService(id, cb) {
    return {
      type: DELETE_SUB_SERVICE,
      id,
      cb,
    };
  }
  static deleteSubServiceSuccess(payload) {
    return {
      type: DELETE_SUB_SERVICE_SUCCESS,
      payload,
    };
  }
  static deleteSubServiceFailure(payload) {
    return {
      type: DELETE_SUB_SERVICE_FAILURE,
      payload,
    };
  }
  static addThirdLayerSubServices(payload) {
    return {
      type: ADD_THIRD_LAYER_SERVICES,
      payload
    }
  }
  static addThirdLayerSubServicesSuccess() {
    return {
      type: ADD_THIRD_LAYER_SERVICES_SUCCESS,
    }
  }
  static addThirdLayerSubServicesFailure() {
    return {
      type: ADD_THIRD_LAYER_SERVICES_FAILURE,
    }
  }
  static updatePriority(payload, cb){
    return {
      type: UPDATE_PRIORITY,
      payload,
      cb
    }
  }
  static updatePrioritySuccess(){
    return {
      type: UPDATE_PRIORITY_SUCCESS
    }
  }
  static updatePriorityFailure(){
    return {
      type: UPDATE_PRIORITY_FAILURE
    }
  }
}
